import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../customformComponent/customForm/DynamicForm";
import backicon from "./../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "../../../../services/api/API";
import { format } from "date-fns";
import Swal from "sweetalert2";
import Loader from "../../../../customComponents/CustomLoader";
import { min18YearsAgo } from "../../../../../constants/DOBCommon";

const EditUser = () => {
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const userType = localStorage.getItem("UserType")
  const [ userTypedd, setUserTypedd ] = useState([])
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([]);
  const [isMultipleCities, setIsMultipleCities] = useState(false);
  const [Required,setRequired] = useState(false)
 
  const location = useLocation()
  const userId = location?.state?.data?.user_id
  const userData = location?.state?.data
  const BUSINESSPARTNERID = location?.state?.data?.business_partner_id
  const [ roleOptions, setRoleOptions ] = useState([])
  const [designationInputs, setDesignationInputs] = useState([]);
  const [showParentDesignation, setShowParentDesignation] = useState(false);
  const [selectedDesignation, setSelectedDesignation] = useState(null);

  // const [roleID, setRoleId] = useState(null)
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");

  const businessPartnerId = localStorage.getItem("business_partner_id")


   const DesignationInputsTemplate = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: [],
            gridClass: "col-lg-4",
            validation: { required: true,
            
           },
           
          },
        ]
      : []),
      {
        name: "firstname",
        label: "First Name",
        placeholder:"Enter First Name",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
         validation: { required: true,
          pattern: /^[A-Za-z0-9-\s]*$/,
          message: "Special symbols are not allowed",
          maxLength:20
       },
      },
      {
        name: "lastname",
        label: "Last Name",
        placeholder:"Enter Last Name",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
         validation: { required: true,
          pattern: /^[A-Za-z0-9-\s]*$/,
          message: "Special symbols are not allowed",
        maxLength:20
       },
      },
      {
        name: "email",
        label: "Email ID",
        placeholder:"Enter Email Address",
        type: "email",
        required: true,
        gridClass: "col-lg-4",  
        validation: { required: true, pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/ , message: "Please enter a valid Email ID"},
      },
      {
        name: "dob",
        label: "DOB",
        type: "date",
        maxDate: new Date(),
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true, message: "DOB is required", },
      },
      {
        name: "jddob",
        label: "Joining Date",
        type: "date",
        maxDate: new Date(),
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true, message: "Joining Date is required" },
      },
      {
        name: "contactno",
        label: "Contact No.",
        placeholder:"Enter Contact No.",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
        validation: { 
          required: true, pattern: /^[6-9]/ ,
          minLength:10,
          maxLength:10,
          message1: "Contact no should start with 6, 7, 8, 9",
          message: "Please enter a valid 10-digit",
        }
      },
      {
        name: "user_address",
        label: "Address",
        placeholder:"Enter Address",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true, message: "Address is required",maxLength:100 },
      },
      {
        name: "pincode",
        label: "Pin Code",
        placeholder:"Enter Pin Code",
        type: "text",
        required: true,
        gridClass: "col-lg-4",
        validation: { required: true, message: "Pincode is required", maxLength: 6 },
      },
      {
        name: "city",
        label: "City",
        placeholder: "City",
        // type: "dropdown",
        type:"text",
        required: false,
        gridClass: "col-lg-4",
        // options: isMultipleCities ? cities.map(city => ({ label: city.city_name, value: city.city_id })) : [],
        
        disabled: true,
      },
      {
        name: "state",
        label: "State",
        placeholder:"State",
        type: "text",
        required: false,
        gridClass: "col-lg-4",
        // validation: { required: true, message: "State is required" },
         disabled:true
      },
      {
        name: "country",
        label: "Country",
        placeholder:"Country",
        type: "text",
        required: false,
        gridClass: "col-lg-4",
        // validation: { required: true, message: "Country is required" },
         disabled:true
      },
    // {
    //   name: "designationlevel",
    //   label: "Designation Level",
    //   type: "dropdown",
    //   required: true,
    //   gridClass: "col-lg-4",
    //   options: [],
    // },
     {
      name:"role_id",
      label:"Role",
      type:"dropdown",
      required: true,
      gridClass: "col-lg-4",
      options: roleOptions,
      validation: { required: true, message: "Role is required",}
    },
    {
      name: "designation_id",
      label: "Designation",
      required: true,
      type: "dropdown",
      gridClass: "col-lg-4",
      options:designationInputs,
      validation: { required: true, message: "Designation is required",}
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
  { label: "Active", value: "Active" },
  { label: "Inactive", value: "Inactive" },
      ],
      validation: {
  required: true,
  message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
    // {
    //   name: "reportingperson",
    //   label: "Reporting Person",
    //   type: "dropdown",
    //   gridClass: "col-lg-4",
    //   isVisible: false,
    //   required:Required,
    //   validation:{required:true},
    //   options: [],
    // },
    // {
    //   name: "parentDesignation",
    //   label: "Parent Designation",
    //   type: "dropdown",
    //   gridClass: "col-lg-4",
    //   isVisible: false, 
    //   required:Required,
    //   validation:{required:true},
    //   options: [],
    // },
  ];

  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      })
      const userTypeOptions = response.data.data.data.map(user => ({
        value: user.onboard_id,
          label:user.bp_name,
      }));

setDesignationInputs((prevInputs) => prevInputs.map((input) => 
input.name === "business_partner_id" ? { ...input, options: userTypeOptions} : input ))

    }catch(error) {
      console.log(error)
    }
  }
  useEffect(()=>{
      userTypedropdown()
  },[])

  useEffect(() => {
    if(formData?.business_partner_id || userType!="superadmin"){
    const fetchData = async () => {
      // await fetchDesignationLevels();
      await fetchRoleDropdown();
      await userTypedropdown()
      // await fetchDepartmentDropdown()
    }
    fetchData();
  }
  },[formData?.business_partner_id])


//   const fetchRoleDropdown = async () => {
//     try {

//       const payload = {
//         // business_partner_id: 1  ,
//       }

//       if (userType === "superadmin") {
//         payload.business_partner_id = formData.business_partner_id;
//       } else {
//         payload.business_partner_id = businessPartnerId;
//       }

//       const response = await axiosInstance.post(
//         "/role/ddlrole",payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${authToken}`,
//           },
//         }
//       );

//       const roleOptions = response.data.data.data.map(user => ({
//         label: user.NAME,
//         value: user.ID,
//       }));

// setDesignationInputs((prevInputs) => prevInputs.map((input) => 
// input.name === "role_id" ? { ...input, options: roleOptions} : input ))

//     } catch (error) {
//       console.error("Error fetching designation levels:", error);
//     }
//   };
  

  useEffect(() => {
    fetchRoleDropdown()
  },[])

  const fetchRoleDropdown = async () => {
    try {

      const payload = {
        // business_partner_id: 1  ,
      }

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      const response = await axiosInstance.post(
        "/role/ddlrole",payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const roleOptions = response.data.data.data.map(user => ({
        label: user.NAME,
        value: user.ID,
      }));
      setRoleOptions(roleOptions)

    } catch (error) {
      console.error("Error fetching designation levels:", error);
    }
  };

  useEffect(() => {
    const roleId = formData?.role_id
    if(roleId){
      fetchDesignationLevels(roleId)
    }
  },[formData?.role_id])

  const fetchDesignationLevels = async (roleId) => {
    try {
      const response = await axiosInstance.post(
        "/designation/ddldesignation",
        {
          role_id:roleId,
          business_partner_id:userType==="superadmin"? formData?.business_partner_id:businessPartnerId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const options = response.data.data.data.map((level) => ({
        label: level.NAME,
        value: level.ID,
        level: level.LEVEL,
      }));
      console.log("options<><>",options);

      setDesignationInputs(options);
    } catch (error) {
      console.error("Error fetching designation levels:", error);
    }
  };
 
  const fetchUserData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/user/edit/${userId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      const userData = response.data.data;
      console.log("userdata<<>>",userData);
      
      setFormData({
        firstname: userData.user_first_name,
        business_partner_id: userData.business_partner_id,
        lastname: userData.user_last_name,
        email: userData.user_email_id,
        dob: userData.user_dob,
        jddob: userData.user_joining_dt,
        contactno: userData.user_contact_no,
        pincode: userData.pincode,
        city: userData.city_id,
        state: userData.state_id,
        country: userData.country_id,
        designation_id: userData.designation_id,
        // role_id:userData.role_id,
        role_id: parseInt(userData.role_id, 10),
        reportingperson: userData.reporting_person_id,
        user_address: userData.user_address,
        department_id: 1,
        status: userData.status === 1 ? "Active" : "Inactive",
      });
     
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(()=>{
fetchUserData()
  },[])
  
  const handleFormSubmit = async () => {
    console.log("formData", formData);
    const errors = {};
    let isValid = true;
    DesignationInputsTemplate.forEach((field) => {
      if (field.required && !formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const formattedDOB = format(new Date(formData.dob), "yyyy-MM-dd");
    const formatJD = format(new Date(formData.jddob), "yyyy-MM-dd");

    Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to update this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const payload = {
            business_partner_id:formData?.business_partner_id?formData?.business_partner_id:BUSINESSPARTNERID,
            user_first_name: formData.firstname,
            user_last_name: formData.lastname,
            user_email_id: formData.email,
            user_contact_no: formData.contactno,
            user_dob: formattedDOB,
            user_address:
              formData.city +
              formData.state +
              formData.country +
              formData.pincode,
            pincode: formData.pincode,
            city_id: formData.city_id,
            state_id: formData.state_id,
            country_id: formData.country_id,
            user_joining_dt: formatJD,
            user_type: "oem",
            designation_id: formData.designation_id,
            reporting_person_id: Number(formData.reportingperson),
            gst_no: formData.gst_no,
            status: formData.status === "Active" ? 1 : 0,
            role_id: formData?.role_id?.toString(),
            department_id: 1,
          };

          // if (userType === "superadmin") {
          //   payload.business_partner_id = formData.business_partner_id;
          // } else {
          //   payload.business_partner_id = businessPartnerId;
          // }

          const response = await axiosInstance.patch(
            `/user/update/${userId}`,
            payload,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${authToken}`,
              },
            }
          );

          console.log("API Response:", response.data);

          Swal.fire({
            title: "Success",
            text: "User updated successfully.",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            navigate("/admin/manage-user/user");
          });
        } catch (error) {
          console.error("Error submitting form:", error);
          const errorMessage =
            error.response?.data?.message ||
            "An error occurred while updating the user.";
          Swal.fire({
            title: "Something went wrong",
            text: errorMessage,
            icon: "error",
            confirmButtonText: "OK",
          });
        } finally {
          setLoading(false);
        }
      } else {
        Swal.fire({
          title: "Cancelled",
          text: "User update cancelled.",
          icon: "info",
          confirmButtonText: "OK",
        });
      }
    });
  };
  

  return (
    <>
     <div>
      {loading ? (
        <Loader />
      ) : (
      <><div className="backbutton mt-2 mb-2" onClick={() => navigate(-1)}>
              <img src={backicon} alt="back" />
              <span className="backbtntitle">Edit User</span>
            </div><div className="form-container">
                <span className="cust-det-title mt-2 mb-2">
                  Please Update User Details
                </span>
                <DynamicForm
                  formConfig={DesignationInputsTemplate}
                  formData={formData}
                  setFormData={setFormData}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors}
                  onSubmit={handleFormSubmit}
                  // showParentDesignation={showParentDesignation} 
                  />
              </div><div className="btncontainer mt-3">
                <button
                  onClick={() => {
                    handleFormSubmit();
                  } }
                  className="submit-btn"
                >
                  Submit
                </button>
              </div></>
      )}
      </div>
    </>
  );
};

export default EditUser;
